export const ProjectsData = [
  {
    title: "Meu Portifólio",
    description:
    "Portifólio criado para demonstrar meus conhecimentos em react, toda funcionalidade foi pensada para demonstrar meus aprendizados durante meus estudos, utilize hooks do react, manipulação de estado, styled-component, react-router, context-api entre outras funcionalidades.",
    tecnologies: "JSX, JavaScript, ReactJs",
    src: "https://i.imgur.com/bk67ldy.jpg",
    alt: "imagem portifólio",
    github: "https://anderson-rodrigo-dev.github.io/portifolio/",
  },
  {
    title: "La Boutik",
    description:
    "Projeto de Ecomerce criado para por em prática aprendizados com programação, iniciei esse projeto com o design no figma, nele criei um database e um login de usuário onde posso criar, remover e editar produtos(CRUD), adicionar produtos ao carrinho e manipular quantidade de produtos para compra.",
    tecnologies: "JSX, JavaScript, ReactJs",
    src: "https://media1.tenor.com/images/02c1ec39e5eebf07f352b155182384d0/tenor.gif?itemid=27647685",
    alt: "imagem LaBoutik",
    github: "https://laboutik-anderson-rodrigo-dev.vercel.app/",
  },
  {
    title: "Database Pokemon",
    description:
    "Projeto feito para simular um teste técnico, nele eu consumo a Api da PokeApi e utilizo react e suas bibliotecas para apresentar os resultados na tela, nele utilizo várias funcionalidades do react, como Styled-Component, React Router e Context-Api.",
    tecnologies: "JSX, JavaScript, ReactJs",
    src: "https://media1.tenor.com/images/40bc4914f0c76f5e7773309e81797a8f/tenor.gif?itemid=27179671",
    alt: "gif da página pokemon",
    github: "https://anderson-rodrigo-dev.github.io/DesafioDevQuestPokemon",
  },
  {
    title: "Palavra Secreta",
    description:
      "Página criada para treinar algumas funcionalidades de react, foi criada em aula e nela podemos criar uma categoría de palavras para tentarmos adivinhar qual é a correta.",
    tecnologies: "JSX, JavaScript, ReactJs",
    src: "https://media1.tenor.com/images/fde779a05c7da4b539e078a44197dbff/tenor.gif?itemid=27179859",
    alt: "gif da página Palavra Secreta",
    github: "https://anderson-rodrigo-dev.github.io/palavra-secreta",
  },
  {
    title: "GitHub Search",
    description:
    " Página criada para aperfeiçoar o consumo de uma API, nesse projeto foi utilizada a API do github, onde utilizei informações do usuário, tais como repositório, commits e stars para apresentar na tela.",
    tecnologies: "HTML, CSS, JavaScript",
    src: "https://media1.tenor.com/images/ea8989b33befbf66f226d8c7b97820b2/tenor.gif?itemid=27179823",
    alt: "gif da página GitHub Search",
    github: "https://anderson-rodrigo-dev.github.io/githubsearch",
  },
  
  
  {
    title: "Agência XYZ",
    description:
      "Langing Page criada para treinar HTML e CSS, foi desenvolvida também para treinar o responsivo e aplicar algumas funcionalidades aprendidas durante as aulas.",
    tecnologies: "HTML, CSS",
    src: "https://media1.tenor.com/images/ab3f2305448a8da0087086c7cc2449e2/tenor.gif?itemid=27184811",
    alt: "gif da página Agência XYZ",
    github: "https://anderson-rodrigo-dev.github.io/agenciaxyz",
  },
  {
    title: "Site XPTO",
    description:
      "Langing Page criada para treinar e aprimorar HTML, CSS e JavaScript, foi desenvolvida durante a MapaDevWeek do curso DevEmDobro, onde iniciei meus estudos em programação e tive meu primeiro contato com JavaScript.",
    tecnologies: "HTML, CSS, JavaScript",
    src: "https://media1.tenor.com/images/b82777eff87b1485c1da8f5cdcdf658a/tenor.gif?itemid=27184813",
    alt: "gif da página Site XPTO",
    github: "https://anderson-rodrigo-dev.github.io/siteXPTO",
  },
  {
    title: "Seleção de Personagem Marvel",
    description:
      "Página criada durante MapaDev Week, evento de programação do curso DevEmDobro, utilizei para treinar meu desempenho em JavaScript e aperfeiçoar a utilização de eventos.",
    tecnologies: "HTML, CSS, JavaScript",
    src: "https://media1.tenor.com/images/9fae04caee6e0d2237c8b18f848551e4/tenor.gif?itemid=27179527",
    alt: "gif da página Marvel",
    github: "https://anderson-rodrigo-dev.github.io/SiteMarvel",
  },
];